import { useContracts, useProvider } from './useContract'
import useEnvConfig from 'hooks/useEnvConfig'
import { ABI_COCOS_BLINDBOX } from '../utils/abis'
import { useWeb3React } from '@web3-react/core'
import { useCallback, useEffect, useState } from 'react'
import http from '../utils/http'
import { BlindBox } from './useMyBlindBox'
import { isEqualString } from '../utils'

export default function useMyOpenedBlindBox() {
  const envConfig = useEnvConfig()
  const [blindBoxes, setBlindBoxes] = useState<BlindBox[]>([])
  const { contract, multiCallContract } = useContracts(envConfig.ADDRESS_OPENED_NFT, ABI_COCOS_BLINDBOX)
  const provider = useProvider()
  const { active, account } = useWeb3React()
  const [loading, setLoading] = useState(false)
  const loadData = useCallback(async () => {
    if (provider && active && multiCallContract && contract) {
      setLoading(true)
      try {
        const balance = +(await contract.balanceOf(account))
        if (balance > 0) {
          const requests = new Array(balance).fill(0).map((x, i) => multiCallContract.tokenOfOwnerByIndex(account, i))
          const infos = await provider.all(requests)
          const tokenUris = await provider.all(infos.map((x) => multiCallContract.tokenURI(x)))
          const data = await Promise.all(
            tokenUris.map((x, i) =>
              http
                .get<BlindBox>(x)
                .then((res) => Object.assign(res.data, { id: +infos[i] }))
                .catch((e) => {
                  return {
                    id: +infos[i],
                  }
                }),
            ),
          )
          setBlindBoxes(data)
        } else {
          setBlindBoxes([])
        }
      } catch (e) {
        setBlindBoxes([])
      } finally {
        setLoading(false)
      }
    }
  }, [multiCallContract, active, provider, account, contract])
  useEffect(() => {
    loadData()
  }, [loadData])
  useEffect(() => {
    if (active && contract) {
      const listener = (sender: string, to: string) => {
        if (isEqualString(sender, account) || isEqualString(to, account)) {
          loadData()
        }
      }
      contract.on('Transfer', listener)
      return () => {
        contract.removeListener('Transfer', listener)
      }
    }
  }, [contract, active, blindBoxes, account, loadData])
  return { blindBoxes, loading }
}
